export default {"src":"/_next/static/media/tenure.112c3122.svg","height":25,"width":22};